/**************************************************
 * Nombre:       Dialogo_Tres
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo.svg'
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import {Check} from '@mui/icons-material'
import {guardarObjLocal} from "../../Servicios/Local/guardarObjLocal";
import Formulario_Tres from "../Formularios/Formulario_Tres";
import {useEffect} from "react";
import {obtenerDoc} from "../../Servicios/BD/obtenerDoc";


const Dialogo_Tres = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Registrando progreso')

        let dox = await guardarDoc('leads', entidad)
        if (dox.res) {
            cerrar()
            guardarObjLocal({key: datos.nombreFunnel, obj: {paso: 4, id: dox.data}})
            realizado()
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }

    }


    useEffect(() => {

        console.log(datos)
        if (datos.id) {
            obtenerDoc('leads', datos.id).then(doc => {
                if (doc.res) {
                    setEntidad(doc.data)
                }
            })
        }

    }, [datos])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{textAlign: 'center', fontWeight: 600, fontSize: 18}}>Ya stas listo para iniciar este
                    camino de exito </Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 2}}>
                <Typography sx={{textAlign: 'center', fontWeight: 400, fontSize: 16}}>
                    Luis
                    Rosero se pondra en contacto contigo, el resolverá tus preguntas y te guiara en el
                    camino de exito!</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 4}}>
                <Formulario_Tres props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    onClick={() => subirDatos()}
                    startIcon={<Check/>}
                >Enviar y Finalizar</Button>
            </Grid>


        </Grid>
    )

}
export default Dialogo_Tres